'use client';

import { c as _c } from "react/compiler-runtime";
import { ControllerRenderProps } from '@repo/sdk/form';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, Popover, PopoverContent, PopoverTrigger } from '@repo/ui/components';
import { Check as CheckIcon, ChevronDown } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import * as React from 'react';
import { countryListWithFlags } from './country-list.tsx';
export const CountrySelect = t0 => {
  const $ = _c(23);
  const {
    className,
    onBlur,
    onChange,
    ref,
    value
  } = t0;
  const [open, setOpen] = React.useState(false);
  let t1;
  if ($[0] !== value) {
    t1 = countryListWithFlags.find(c => c.code === value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selected = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("flex h-9 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-sm ring-offset-background placeholder:text-muted-foreground focus:ring-1 focus:ring-ring focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 dark:bg-neutral-900 [&>span]:line-clamp-1", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const triggerClasses = t2;
  let t3;
  if ($[4] !== selected) {
    t3 = selected ? <div className="flex w-0 flex-grow items-center gap-2 overflow-hidden"><span className="overflow-hidden text-ellipsis whitespace-nowrap">{selected.label}</span></div> : <span className="inline-flex items-center gap-2 text-muted-foreground">Country</span>;
    $[4] = selected;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronDown className="ml-2 shrink-0" size={16} data-sentry-element="ChevronDown" data-sentry-source-file="select.tsx" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onBlur || $[8] !== ref || $[9] !== t3 || $[10] !== triggerClasses) {
    t5 = <PopoverTrigger className={triggerClasses} onBlur={onBlur} ref={ref} type="button" data-sentry-element="PopoverTrigger" data-sentry-source-file="select.tsx">{t3}{t4}</PopoverTrigger>;
    $[7] = onBlur;
    $[8] = ref;
    $[9] = t3;
    $[10] = triggerClasses;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="sticky top-0 z-10 bg-popover"><CommandInput placeholder="Search country..." data-sentry-element="CommandInput" data-sentry-source-file="select.tsx" /></div>;
    t7 = <CommandEmpty data-sentry-element="CommandEmpty" data-sentry-source-file="select.tsx">No country found.</CommandEmpty>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onChange || $[15] !== selected?.code) {
    t8 = countryListWithFlags.map(country => <CommandItem className="flex w-full items-center gap-2" key={country.code} onSelect={() => {
      onChange(country.code);
      setOpen(false);
    }} value={typeof country.label === "string" ? country.label : country.name}><div className="flex w-0 flex-grow items-center gap-2 overflow-hidden"><span className="overflow-hidden text-ellipsis whitespace-nowrap">{country.label}</span></div>{selected?.code === country.code ? <CheckIcon className="ml-auto h-4 w-4 shrink-0" /> : null}</CommandItem>);
    $[14] = onChange;
    $[15] = selected?.code;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <PopoverContent align="start" className="min-w-[--radix-popper-anchor-width] p-0" collisionPadding={10} side="bottom" data-sentry-element="PopoverContent" data-sentry-source-file="select.tsx"><Command className="max-h-[200px] w-full sm:max-h-[270px]" data-sentry-element="Command" data-sentry-source-file="select.tsx">{t6}{t7}<CommandList data-sentry-element="CommandList" data-sentry-source-file="select.tsx"><CommandGroup data-sentry-element="CommandGroup" data-sentry-source-file="select.tsx">{t8}</CommandGroup></CommandList></Command></PopoverContent>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== open || $[20] !== t5 || $[21] !== t9) {
    t10 = <Popover onOpenChange={setOpen} open={open} data-sentry-element="Popover" data-sentry-component="CountrySelect" data-sentry-source-file="select.tsx">{t5}{t9}</Popover>;
    $[19] = open;
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default CountrySelect;